export const errorsConstants = {
  ERROR_404: 'ERROR_404',
  ERROR_500: 'ERROR_500',
  ERROR_OTHER: 'ERROR_OTHER',
  ERROR_RESET: 'ERROR_RESET',
};
